import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import Button from 'jbc-front/components/Button';

import { reduxForm, getFormValues } from 'redux-form';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { FileField } from '../../jbc-front/components/Form';
import { Download, Upload } from 'jbc-front/components/icons';
import { ErrorsSection } from 'src/components';
import { UPDATE_BATCH_CSV, TEMPLATE_EMPLOYEES_CSV } from 'src/constants/EndpointUrls';
import isUseOtherApp from 'src/utils/JbcId';
import { getSelectOptions } from 'src/reducers/selectOptions';
import DownloadCsvEncodingRadioButton from 'src/components/DownloadCsvEncodingRadioButton';

// Reducer
import { getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, importEmployeeCsv } from 'src/reducers/employees/employees';
import { redirectTo, serializeHttpGetParams } from 'src/utils/Http';

import { ENCODING_OPTIONS } from 'src/constants/Options';
import AnyJobRunning from './components/AnyJobRunning';
import AnyApiRunning from './components/AnyApiRunning';
import FileImportDescription from './components/FileImportDescription';
import styles from './styles/FileImport.scss';
import { useTranslation } from 'react-i18next';

let FormContainer = reduxForm({
  form: EMPLOYEE_FORM,
  enableReinitialize: true
})(({ submitting, handleSubmit, errors, selectedEncoding }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <div className={styles.head}>{t('features.Employees.InsertBatchCsv.upload_process')}</div>
      <div className={styles.body}>
        <form onSubmit={handleSubmit}>
          <ErrorsSection errors={errors} />

          <dl className={styles.label}>
            <dt className={styles.number}>1</dt>
            <dd className={styles.detail}>
              <p className={styles.text}>{t('features.Employees.InsertBatchCsv.select_the_output_format_and_use_the_downloaded_CSV_file')}</p>
              <div className="u-mt30">
                <DownloadCsvEncodingRadioButton
                  name={'encoding'}
                  label={null}
                  options={ENCODING_OPTIONS}
                  required={false}
                />
              </div>
              <Button
                widthWide
                onClick={() =>
                  redirectTo(`${TEMPLATE_EMPLOYEES_CSV}?${serializeHttpGetParams({ encoding: selectedEncoding })}`)
                }
                icon={<Download size={16} />}
              >
                {t('features.Employees.InsertBatchCsv.download_sample_data')}
              </Button>
            </dd>
          </dl>

          <dl className={styles.label}>
            <dt className={styles.number}>2</dt>
            <dd className={styles.detail}>
              {t('features.Employees.InsertBatchCsv.enter_the_information_of_the_employee_you_want_to_register_in_the_downloaded_CSV_file_while_referring_to_the_explanation_below')}
              <div className={styles.warning}>
                <span className={styles.warningTitle}>{t('features.EmployeePays.components.EmployeePayDownloadCsvForm.warning')}</span>
                <ul className={styles.warningList}>
                  <li>
                    {isUseOtherApp && <span>①</span>}
                    {t('features.Employees.InsertBatchCsv.the_following_items')}<span className={styles.requiredText}>{t('features.Employees.InsertBatchCsv.are')}</span>{t('features.Employees.InsertBatchCsv.required')}
                    <ul className={styles.requireList}>
                      <li>・{t('features.Employees.InsertBatchCsv.last_name')}</li>
                      <li>・{t('features.Employees.InsertBatchCsv.first_name')}</li>
                      <li>・{t('features.Employees.InsertBatchCsv.first_day_at_work')}</li>
                      <li>・{t('features.Employees.InsertBatchCsv.salary_rule_group')}</li>
                      {/* <li>・{t('features.Employees.InsertBatchCsv.when_registering_commuting_allowance_information')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.commuting_method')}</li>
                      <li>・{t('features.Employees.InsertBatchCsv.when_registering_dependent_information')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.dependent_relationship')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.dependent_last_name')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.dependent_first_name')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.dependent_birth_date')}</li> */}
                      <li>・{t('features.Employees.InsertBatchCsv.when_registering_payment_setting_salary_bank_transfer_1_amount')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.payment_setting_salary_bank_transfer_1_recipient')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.payment_setting_salary_bank_transfer_1_transfer_source')}</li>
                      {/* <li>・{t('features.Employees.InsertBatchCsv.when_registering_payment_setting_bonus_bank_transfer_1_amount')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.payment_setting_bonus_bank_transfer_1_recipient')}</li>
                      <li>　　・{t('features.Employees.InsertBatchCsv.payment_setting_bonus_bank_transfer_1_transfer_source')}</li> */}
                    </ul>
                  </li>
                  {isUseOtherApp && (
                    <li>
                      {t('features.Employees.InsertBatchCsv.2_If_the_user_to_be_registered_is_also_registered_in_other_JOBCAN_services')}
                      <span className={styles.requiredText}>
                        {t('features.Employees.InsertBatchCsv.the_entered_first_and_last_name_staff_code_and_e_mail_address_will_be_automatically_reflected_in_the_Jobcan_service_you_are_using')}
                      </span>
                    </li>
                  )}
                </ul>
              </div>
            </dd>
          </dl>

          <dl className={styles.label}>
            <dt className={styles.number}>3</dt>
            <dd className={styles.detail}>
              <p className={styles.text}>{t('features.Employees.InsertBatchCsv.select_the_completed_file_and_upload_it')}</p>
              <FileField name="employee_csv" className={styles.input} />
            </dd>
          </dl>
          <Button as="button" primary type="submit" disabled={submitting} icon={<Upload size={16} />} widthWide>
            {t('features.Employees.InsertBatchCsv.upload')}
          </Button>
        </form>
      </div>
    </div>
  )
});

FormContainer = connect(
  state => ({
    errors: getItemErrors(REDUCER_NAME, state),
    selectedEncoding: _.get(getFormValues(EMPLOYEE_FORM)(state), 'encoding'),
    initialValues: { encoding: 'UTF-8' }
  }),
  dispatch => ({
    onSubmit: data => dispatch(importEmployeeCsv(data))
  })
)(FormContainer);

const InsertBatchCsv = ({ anyJobRunning, anyApiRunning }) => {
  const { t } = useTranslation();
  return (
    <div>
      {anyJobRunning && <AnyJobRunning />}
      {anyApiRunning && <AnyApiRunning />}
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.Employees.InsertBatchCsv.register_employee_information')}</h1>
        <p className="m-title-main-note">
          {t('features.Employees.InsertBatchCsv.employee_information_can_be_registered_in_a_batch')}<br />※ {t('features.Employees.InsertBatchCsv.when_updating_registered_employee_information')}<a
            href={UPDATE_BATCH_CSV}
            className="u-txt-link"
          >
            {t('features.Employees.InsertBatchCsv.here')}
          </a>
        </p>
        <br />
        <p className={styles.requiredText}>
          {t('features.Employees.InsertBatchCsv.you_can_register_up_to_500_employees_at_once')}<br />
          {t('features.Employees.InsertBatchCsv.if_you_have_more_than_500_employees_please_register_multiple_times')}
        </p>
      </div>
      <FormContainer />
      <div className={styles.description}>
        <FileImportDescription />
      </div>
    </div>
  );
};

export default connect(state => ({
  anyJobRunning: getSelectOptions(state, 'anyJobRunning'),
  anyApiRunning: getSelectOptions(state, 'anyApiRunning')
}))(InsertBatchCsv);
